module.exports = __webpack_public_path__ + "img/amx-18.e825783d.webp";